import { lazy } from 'react'

/**
 * `lazy()`, переживающий выкладку новой версии.
 *
 * ЗАЧЕМ. Vite режет сборку на части с хешем в имени: `FeederMap-B-O5HISU.js`.
 * После выкладки имена меняются, а у человека в браузере остаётся старый
 * `index.html` со старыми именами. Он нажимает пункт меню, браузер просит
 * часть, которой больше нет, — и приложение падает в белый экран. Перезагрузка
 * всё чинит, потому что подтягивает свежий `index.html`.
 *
 * Именно так выглядела жалоба 04.10.2026: «нажимаю, белый экран, пока не
 * перезагружу». Воспроизвести на свежей вкладке нельзя — нужна именно вкладка,
 * открытая до выкладки.
 *
 * Поэтому здесь: не нашли часть — перезагружаем страницу один раз. Отметка о
 * попытке живёт в sessionStorage, чтобы при настоящей поломке (часть удалена
 * совсем, сеть лежит) не получить бесконечную перезагрузку; тогда ошибка
 * пойдёт дальше, в границу ошибок, и человек увидит текст, а не пустоту.
 */
const RELOAD_KEY = 'urbanpurr.chunkReload'

export function lazyChunk(factory) {
  return lazy(() =>
    factory().catch((error) => {
      let tried = false
      try {
        tried = sessionStorage.getItem(RELOAD_KEY) === '1'
        if (!tried) sessionStorage.setItem(RELOAD_KEY, '1')
      } catch {
        // Приватный режим: sessionStorage недоступен. Тогда не перезагружаем
        // вовсе — лучше показать ошибку, чем зациклить вкладку.
        tried = true
      }
      if (!tried) {
        window.location.reload()
        // Промис намеренно не разрешается: страница уже уходит на перезагрузку,
        // и показывать что-либо не нужно.
        return new Promise(() => {})
      }
      throw error
    }),
  )
}

/** Снять отметку после удачной загрузки приложения — чтобы следующая выкладка снова имела право на одну перезагрузку. */
export function clearChunkReloadMark() {
  try {
    sessionStorage.removeItem(RELOAD_KEY)
  } catch {
    // неважно
  }
}
